module.exports = __webpack_public_path__ + "static/media/qrCodeBackgroundCanteen.04e683e4.png";